module.exports = __webpack_public_path__ + "static/media/img135.82cc5c56.jpg";